module.exports = __webpack_public_path__ + "static/media/k3_kitten.a0119af0.png";